module.exports = __webpack_public_path__ + "img/cr.21f39607.svg";